import { useState } from 'react'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useHomeStore } from '../store'

interface Props {
  onAdded: (carIds: number[]) => void
}

const VIN_RE = /^[A-HJ-NPR-Z0-9]+$/i

export function ManualVinCard({ onAdded }: Props) {
  const [raw, setRaw] = useState('')
  const [error, setError] = useState<string | null>(null)
  const addVehicles = useHomeStore((s) => s.addVehicles)
  const hasVin = useHomeStore((s) => s.hasVin)

  function submit() {
    setError(null)
    const tokens = raw
      .split(/[\s,;]+/)
      .map((t) => t.trim().toUpperCase())
      .filter(Boolean)
    if (tokens.length === 0) {
      setError('Vyplňte VIN.')
      return
    }
    const invalid: string[] = []
    const accepted: { vin: string }[] = []
    for (const t of tokens) {
      const ok = (t.length === 17 || (t.length >= 7 && t.length <= 9)) && VIN_RE.test(t)
      if (!ok) {
        invalid.push(t)
        continue
      }
      if (hasVin(t)) continue
      accepted.push({ vin: t })
    }
    if (invalid.length > 0 && accepted.length === 0) {
      setError(`VIN musí mít 7–9 nebo 17 znaků. Neplatné: ${invalid.join(', ')}`)
      return
    }
    const ids = addVehicles(accepted)
    setRaw('')
    if (ids.length > 0) onAdded(ids)
    if (invalid.length > 0) setError(`Přidáno ${ids.length} vozidel. Neplatné: ${invalid.join(', ')}`)
  }

  return (
    <div>
      <h3 className="mb-3 font-medium text-zinc-900">Ruční přidání vozidla</h3>
      <div className="space-y-2">
        <label className="block text-sm font-medium text-zinc-700">
          Vložte VIN (jeden na řádek nebo oddělené čárkou/mezerou)
        </label>
        <div className="flex">
          <textarea
            rows={3}
            value={raw}
            onChange={(e) => setRaw(e.target.value)}
            placeholder={`Zadejte VIN\nNapř:\nYV2RTY0A5SB517846\nTMBEFF654V7529422`}
            className="flex-1 resize-none rounded-l-md border border-zinc-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand"
          />
          <Button onClick={submit} className="rounded-l-none">
            <Plus className="h-4 w-4" />
          </Button>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    </div>
  )
}
